import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import { Chart } from 'components/Chart';
import { useOutletContext } from 'react-router-dom';
import { StockContextType } from './StockPage';
import { useMemo } from 'react';
import { usePageTitle } from 'routes/Util/Util.hooks';

export const InfoPage = () => {
  const { symbol, stock } = useOutletContext<StockContextType>();
  usePageTitle(`${stock.krShortName} 정보`);
  const locale = stock.country === 'us' ? 'en-US' : 'ko-KR';
  const currency = stock.country === 'us' ? 'USD' : 'KRW';
  const numberFormat = useMemo(() => new Intl.NumberFormat(locale, { style: 'currency', currency }), [currency, locale]);


  return (
    <Row>
      <Col sm={12} lg={6}>
        <Chart symbol={symbol} />
      </Col>
      <Col sm={12} lg={6} className="mt-3 mt-lg-0">
        <dl className="row">
          <dt className="col-3">현재 가격</dt>
          <dd className="col-9">{numberFormat.format(stock.regularMarketPrice)}</dd>
          <dt className="col-3">52주 최저</dt>
          <dd className="col-9">{numberFormat.format(stock.fiftyTwoWeekLow)}</dd>
          <dt className="col-3">52주 최고</dt>
          <dd className="col-9">{numberFormat.format(stock.fiftyTwoWeekHigh)}</dd>
          <dt className="col-3">고점 대비</dt>
          <dd className="col-9">{stock.declineRate.toFixed(1)}%</dd>
          <dt className="col-3">PER</dt>
          <dd className="col-9">{stock.trailingPE ? stock.trailingPE.toFixed(1) : '-'}</dd>
          <dt className="col-3">추정 PER</dt>
          <dd className="col-9">{stock.forwardPE ? stock.forwardPE.toFixed(1) : '-'}</dd>
        </dl>
      </Col>
    </Row>
  );
};
